import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import * as loginActions from '../actions/loginActions';
import { getCurrentTimeStamp } from '../api/dateFormat';

export function fetchDashboard(response) {
  return {
    type: types.DASH_BOARD,
    response,
  };
}

export const fetchDashboardData = async (jwtToken, dispatch) => {
  const body = {};
  const url = 'api/student/dashboard';
  await fetchPost(url, body, jwtToken)
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      if (data.error) {
        console.log('some issue in API');
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(loginActions.logOut());
      }
      data['timestamp'] = getCurrentTimeStamp();
      dispatch(fetchDashboard(data));
    });
};
